import { useState, useEffect, useCallback } from 'react';
import axios from 'Axios';
import moment from 'moment-jalaali';
import { Link } from 'react-router-dom';
import { ArrowBarUp, Plus } from 'tabler-icons-react';
import { useModal, useDelayUnmount } from 'Hooks';
import { api, slugify, clx, fileType, Names } from 'Utils';
import {
	ContentBox,
	DataTable,
	DataTableHead,
	DataTableBody,
	DataTableList,
	DataTableRow,
	DataTableRowCell,
	DataTableRowList,
	DataTableLoading,
	DataTableOperation,
	DataPagination,
	ModalBoxDeleteContent,
	ModalBoxEditContent
} from 'Elements';
import styles from 'partials/dashboard/user-content.module.scss';

export const UserContentList = () => {
	const [state, setState] = useState({
		list: [],
		isLoading: true,
		totalCount: 0,
		itemPerPage: 10,
		currentPage: 1,
		lastPage: 1,
		selectedRow: {},
		modalName: 'delete'
	});
	const [openModal, toggleModal] = useModal();
	const shouldRenderModal = useDelayUnmount(openModal, 350);

	const getList = useCallback(
		(page = state.currentPage) => {
			const data = {
				limit: state.itemPerPage
			};
			setState((prev) => ({
				...prev,
				isLoading: true
			}));
			const apiUrl = `${api.productions}?page=${page}`;
			axios.post(apiUrl, data).then((res) => {
				const data = res?.data;
				if (data?.success) {
					setState((prev) => ({
						...prev,
						isLoading: false,
						list: data.list,
						totalCount: data.meta.total,
						lastPage: data.meta.last_page
					}));
				}
			});
		},
		[state.currentPage, state.itemPerPage]
	);

	const checkLastItem = () => {
		// we have to check if totalCount - 1 devided by itemPerPage isInteger,
		// if isInteger, this is the last item on page, else we have to getData of currentPage
		let currentPage = state.currentPage;
		const totalItem = state.totalCount - 1;
		const isLastItem = Number.isInteger(totalItem / state.itemPerPage);

		// check where loadData from currentPage or currentPage - 1
		const isLastPage = state.lastPage === currentPage;
		if (isLastItem && isLastPage) {
			setState((prev) => ({
				...prev,
				currentPage: prev.currentPage - 1
			}));
		}
		return isLastItem ? currentPage - 1 : currentPage;
	};

	const handleEditProduction = (production) => {
		console.log('story edit: ', production);
	};

	// const onEditRow = (row) => {
	// 	setState((prev) => ({
	// 		...prev,
	// 		selectedRow: row
	// 	}));
	// 	toggleModalUpdate();
	// };

	const onSelectOperation = (type, row) => {
		setState((prev) => ({
			...prev,
			modalName: type,
			selectedRow: row
		}));
		toggleModal();
	};

	const renderModal = () => {
		const modal = {
			edit: ModalBoxEditContent,
			delete: ModalBoxDeleteContent
		};
		const DynamicModal = modal[state.modalName.toString()];
		return (
			<DynamicModal
				isOpen={openModal}
				onClose={toggleModal}
				story={state.selectedRow}
				onDelete={() => getList(checkLastItem())}
				onEdit={handleEditProduction}
			/>
		);
	};

	const renderOperation = (elem) => {
		switch (elem.status) {
			case 'pending':
				return (
					//onSelectOperation('edit', elem)}
					<DataTableOperation
						onEditRow={() => console.log('edit')}
						onDeleteRow={() => onSelectOperation('delete', elem)}
					/>
				);
			case 'rejected':
				return (
					<DataTableOperation
						onEditRow={() => console.log('edit')}
						onDeleteRow={() => onSelectOperation('delete', elem)}
					/>
				);
			case 'accepted':
				return (
					<Link
						to={`${Names.story.path}/${elem.story.id}/${slugify(
							elem.story.title
						)}`}
						className={styles.tableActionLink}>
						مشاهده
					</Link>
				);
			default:
				return <div>---</div>;
		}
	};

	const renderStatus = (status) => {
		switch (status) {
			case 'pending':
				return (
					<span
						className={clx(
							styles.tableAction,
							styles.tableActionLabel
						)}>
						در صف بررسی
					</span>
				);
			case 'rejected':
				return (
					<span
						className={clx(
							styles.tableAction,
							styles.tableActionLabel,
							styles.tableActionRed
						)}>
						رد شده
					</span>
				);
			case 'accepted':
				return (
					<span
						className={clx(
							styles.tableAction,
							styles.tableActionLabel,
							styles.tableActionGreen
						)}>
						تایید شده
					</span>
				);
			default:
				return (
					<span
						className={clx(
							styles.tableAction,
							styles.tableActionLabel
						)}>
						در صف بررسی
					</span>
				);
		}
	};

	const handlePageChange = (pageNumber) => {
		setState((prev) => ({
			...prev,
			currentPage: pageNumber
		}));
	};

	useEffect(() => {
		getList();
	}, [getList]);

	return (
		<ContentBox
			title="لیست محتوای ارسالی"
			icon={ArrowBarUp}
			subtitle={`شما تا کنون ${state.totalCount} محتوا برای روایت ها ثبت کرده اید`}
			headerButton={
				<Link
					to={Names.upload.path}
					className={clx(styles.headerSubmit, styles.bgcolorSubmit)}>
					<Plus className={styles.headerSubmitIcon} size="22" />
					ارسال محتوا
				</Link>
			}>
			<DataTable>
				<DataTableHead>
					<DataTableRowList>
						<DataTableRowCell
							cellClassName="w-25"
							cellText="عنوان روایت"
						/>
						<DataTableRowCell
							cellClassName="w-10"
							cellText="نوع محتوا"
						/>
						<DataTableRowCell
							cellClassName="w-25"
							cellText="عنوان محتوا"
						/>
						<DataTableRowCell
							cellClassName="w-15"
							cellText="تاریخ ارسال"
						/>
						<DataTableRowCell
							cellClassName="w-15"
							cellText="وضعیت"
						/>
						<DataTableRowCell
							cellClassName="w-10"
							cellText="عملیات"
						/>
					</DataTableRowList>
				</DataTableHead>
				<DataTableBody>
					<DataTableList>
						{!state.isLoading &&
							state.list?.map((elem) => {
								return (
									<DataTableRow key={elem.id}>
										<DataTableRowList>
											<DataTableRowCell
												cellClassName="w-100 w-md-25"
												cellHead="عنوان روایت">
												<Link
													to={`${Names.story.path}/${
														elem.story.id
													}/${slugify(
														elem.story.title
													)}`}
													title={elem.story.title}
													className={clx(
														styles.textBold,
														styles.textOverflow
													)}>
													{elem.story.title}
												</Link>
											</DataTableRowCell>
											<DataTableRowCell
												cellClassName="w-100 w-md-10"
												cellHead="نوع محتوا"
												cellText={
													fileType[elem.type]?.title
												}
											/>
											<DataTableRowCell
												cellClassName="w-100 w-md-25"
												cellHead="عنوان محتوا">
												<span
													title={elem.title}
													className={
														styles.textOverflow
													}>
													{elem.title}
												</span>
											</DataTableRowCell>
											<DataTableRowCell
												cellClassName="w-100 w-md-15"
												cellHead="تاریخ"
												cellText={moment(
													elem.created_at
												).format('jYYYY/jMM/jDD')}
											/>
											<DataTableRowCell
												cellClassName="w-100 w-md-15"
												cellText={renderStatus(
													elem.status
												)}
												cellHead="وضعیت"
											/>
											<DataTableRowCell
												cellClassName="w-100 w-md-10"
												cellHead="عملیات">
												{renderOperation(elem)}
											</DataTableRowCell>
										</DataTableRowList>
									</DataTableRow>
								);
							})}
					</DataTableList>
					<DataTableList>
						{state.isLoading && <DataTableLoading />}
					</DataTableList>
				</DataTableBody>
			</DataTable>
			{state.totalCount > 0 && (
				<DataPagination
					totalItemsCount={state.totalCount}
					itemsCountPerPage={state.itemPerPage}
					activePage={state.currentPage}
					onChange={handlePageChange}
				/>
			)}
			{shouldRenderModal && renderModal()}
		</ContentBox>
	);
};
